import api from "./api";
import { toast } from "sonner";

const KEY = "erp_offline_queue";

export function queueSize() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]").length; } catch { return 0; }
}

export function queueRequest(url, payload, label) {
  const q = JSON.parse(localStorage.getItem(KEY) || "[]");
  q.push({ url, payload, label, queued_at: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("offline-queue-change"));
}

export async function flushQueue() {
  const q = JSON.parse(localStorage.getItem(KEY) || "[]");
  if (!q.length || !navigator.onLine) return 0;
  const failed = [];
  let sent = 0;
  for (const item of q) {
    try {
      await api.post(item.url, item.payload);
      sent++;
    } catch (e) {
      if (e.response) {
        toast.error(`${item.label || "Data antrian"} gagal: ${e.response.data?.detail || "ditolak server"}`);
      } else {
        failed.push(item);
      }
    }
  }
  localStorage.setItem(KEY, JSON.stringify(failed));
  window.dispatchEvent(new Event("offline-queue-change"));
  if (sent > 0) toast.success(`${sent} data offline berhasil terkirim`);
  return sent;
}
